import React, {Component} from 'react';
import PageTemplate from '../components/PageTemplate/PageTemplate';
import BasicText from '../components/BasicText/BasicText';
import ActionButton from '../components/ActionButton/ActionButton';
import DeviceQueryContainer from './DeviceQueryContainer';
import {NestActions} from '../../../store/actionCreators';
import {getOS} from '../../../lib/functions';

class DeviceViewContainer extends Component {

  handleSignOut = () => {
    // Won't work on android if os of core store is used
    const OS = getOS(window.navigator.userAgent);

    if (OS === 'Android') {
      window.android && window.android.dismiss();
    } else if (OS === 'iOS') {
      window.location.replace('awair://dismiss');
    }
  };

  render() {
    const {contents} = this.props;
    NestActions.convertToInitialValue(false);
    return (
      <PageTemplate>
        <BasicText text={contents.nestChoiceText}/>
        <DeviceQueryContainer />
        <ActionButton negative={true}
                      text={contents.nestLogoutBtnText}
                      onClick={this.handleSignOut}/>
      </PageTemplate>
    );
  }
}

export default DeviceViewContainer;


// WEBPACK FOOTER //
// ./src/app/nest/containers/DeviceViewContainer.js